import * as React from "react";
import Component from "./AbstractComponent";
import Logger from "../Logger/Logger";
import Url from "../Url/Url";
import { connect } from "react-redux";
import { firstTasksToFinish } from "../Saga/Sequences/AuthSequence";
import { tasks } from "../Saga/Sequences/AuthSequence";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { createMuiTheme } from "@material-ui/core/styles";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import Button from "@material-ui/core/Button";
import Constants from "../Action/Constants";
import Container from "./Pages/Container";

const theme = createMuiTheme({
  typography: {
    fontSize: 14,
  },
  palette: {
    primary: {
      main: "#00BCD4",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#f44336",
    },
  },
  overrides: {
    MuiFormControlLabel: {
      label: {
        fontFamily: "Roboto, sans-serif !important",
      },
    },
  },
});

class Layout extends Component {
  protected entitiesToFetch: number = [...firstTasksToFinish, ...tasks].length;
  public state: {
    hasException: boolean;
  } = {
    hasException: false,
  };

  constructor(public props) {
    super(props);
  }

  public componentDidCatch(error, info) {
    this.setState({
      hasException: true,
    });

    Logger.warn(info);
    console.log(error);
    Logger.logError(error, "critical");
  }

  protected closeSnackbar = (id) => {
    this.props.dispatch({
      type: Constants.SNACKBAR_REMOVE_MESSAGE,
      payload: {
        id: id,
      },
    });
  };

  public renderSnackbar = (snackbar): any => {
    return (
      <Snackbar
        className={`snackbar-wrapper ${
          snackbar.type === "success" ? "hide-close-button" : ""
        }`}
        open={true}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        autoHideDuration={
          snackbar.type === "success"
            ? this.props.app?.normalSnackbarDelay
            : this.props.app?.persistentSnackbarDelay
        }
        onClose={this.closeSnackbar.bind(this, snackbar.id)}
        key={`snackbar-${snackbar.id}`}
        ClickAwayListenerProps={{ mouseEvent: false }}
      >
        <MuiAlert
          className="snackbar-alert"
          elevation={6}
          variant="outlined"
          onClose={this.closeSnackbar.bind(this, snackbar.id)}
          severity={snackbar.type}
          key={`alert-${snackbar.id}`}
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    );
  };

  public render() {
    // If we had an exception, show the crash page.
    if (this.state.hasException === true) {
      return (
        <div>
          <MuiThemeProvider theme={theme}>
            <div className="preloader">
              <h1>Casadesk</h1>
              <h3>{this.trans("application-crashed")}</h3>
              <h4>{this.trans("application-crashed-notice")}</h4>

              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  (window as any).location = Url.to("auth/check-email", false);
                }}
              >
                {this.trans("button-back-to-signin")}
              </Button>
            </div>
          </MuiThemeProvider>
        </div>
      );
    }

    // If we are logged out, then we should open auth section of the app.
    if (this.props.token.token.length === 0) {
      return (
        <MuiThemeProvider theme={theme}>
          <div>
            {this.props.app?.snackbars?.length > 0 &&
              this.renderSnackbar(this.props.app?.snackbars?.[0])}

            {this.props.children}
          </div>
        </MuiThemeProvider>
      );
    }

    // If application is still fetching the data from backend, render loading screen again.
    if (this.props.app.loadedEntities.length !== this.entitiesToFetch) {
      return (
        <div>
          <MuiThemeProvider theme={theme}>
            <div className="preloader" id="loader-text">
              <h1>Casadesk</h1>
              <h3>
                {this.trans("application-starting-notice")}
                <div className="loader-dots">
                  <div className="dot dot1"></div>
                  <div className="dot dot2"></div>
                  <div className="dot dot3"></div>
                  <div className="dot dot4"></div>
                </div>
              </h3>
            </div>
          </MuiThemeProvider>
        </div>
      );
    }

    // Otherwise, render the application.
    return (
      <div>
        <MuiThemeProvider theme={theme}>
          <div>
            <Container {...this.props} />
          </div>
        </MuiThemeProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    app: state.app,
    events: state.events,
    tasks: state.tasks,
    token: state.token,
    globalTypes: state.globalTypes,
  };
};

export default connect(mapStateToProps)(Layout);
